import React from 'react';
import { CheckIcon, SearchIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
const assurances = ['Garantía de 7 días', 'Pago seguro', 'Acceso inmediato', 'Material listo para usar desde hoy'];
export function FinalCta() {
  return <section className="bg-navy-950 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-78" data-mp="1jcd58c5js2d2">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-79" data-mp="1eek1rqvmpmgh">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-silver-200" data-id="element-80" data-mp="1ebxvdukh5czu">
          <SearchIcon className="h-4 w-4" aria-hidden="true" data-id="element-81" data-mp="1o3v6707km2y1" /> {productShortName}
        </p>
        <h2 id="final-title" className="mx-auto mt-5 max-w-2xl text-balance text-3xl font-extrabold text-white sm:text-4xl" data-id="element-82" data-mp="1o67pbgp2ejco">
          Hecho por especialistas, para docentes de Latinoamérica.
        </h2>

        <Countdown light className="mt-8" data-id="element-83" data-mp="n5m887qsge4i" />

        <div className="mt-8 flex flex-col gap-5 rounded-xl border-2 border-silver-300 bg-navy-800 p-6 text-left shadow-2xl shadow-black/40 sm:flex-row sm:items-center sm:justify-between" data-id="element-84" data-mp="n6w72z5gtqc7">
          <p data-id="element-85" data-mp="x2que7kmw9lb">
            <b className="block font-serif text-base leading-tight tracking-tight text-white" data-id="element-86" data-mp="x2z4xstab2tc">{productShortName}</b>
            <span className="text-sm text-silver-200" data-id="element-87" data-mp="1246he56dgq6c">
              {totalVolumes} tomos + {totalBonuses} bonos · Acceso inmediato
            </span>
          </p>
          <div className="shrink-0 sm:text-right" data-id="element-88" data-mp="1b2i3btwamzsg">
            <p className="text-sm text-silver-300" data-id="element-89" data-mp="1b171w0qbm44i">
              <span className="mr-2 line-through" data-id="element-90" data-mp="1fvbbkrqz0q9a">{priceBefore}</span>
              <b className="text-lg text-white" data-id="element-91" data-mp="1kt38y1adx4kv">{price}</b>
            </p>
            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" size="sm" className="mt-2" data-id="element-92" data-mp="1kv7bofwjrxjk">
              Quiero mi Megapack ahora
            </Button>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-silver-200" data-id="element-93" data-mp="1tropxs07kbjj">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-94" data-mp="3lwncy69ycobt">
              <CheckIcon className="h-4 w-4 text-silver-300" aria-hidden="true" data-id="element-95" data-mp="3i4puut6dett" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}